export enum contractTabItems {
  Assets,
  PaymentSchedule,
  Collaterals,
  Insurances,
}
